module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"soon":"Próximamente...","categories":{"product":"Productos","service":"Servicios","donation":"Donaciones"}},"en":{"soon":"Soon...","categories":{"product":"Products","service":"Services","donation":"Donations"}}}')
  delete Component.options._Ctor
}
